import { provideAppInitializer, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { AuthActions } from 'src/app/state/store/auth/auth.actions';

/**
 * App initializer that dispatches AuthActions.isSessionExist
 * and resolves when either isSessionExistSuccess or isSessionExistFailure fires.
 *
 * This uses the new `provideAppInitializer` API (Angular v19+) and `inject` to obtain
 * DI tokens inside the initializer.
 */
export const APP_INIT_PROVIDER = provideAppInitializer(() => {
  console.log(`Inside Initializer`);
  const actions$ = inject(Actions);
  const store = inject(Store);

  // Dispatch the action which will trigger the Auth effect to check session.
  // Provide current path as intendedUrl so post-session redirect keeps user on same deep link.
  const currentPath = globalThis.location?.pathname || '/';
  store.dispatch(AuthActions.isSessionExist({ intendedUrl: currentPath }));

  // Return a promise that resolves when either success or failure action arrives
  return firstValueFrom(
    actions$.pipe(
      ofType(
        AuthActions.isSessionExistSuccess,
        AuthActions.isSessionExistFailure
      )
    )
  ).then(() => void 0);
});
